module.exports = "mutation deleteFieldOfLaw($id:String!){deleteFieldOfLaw(id:$id){name id}}"